<template>
  <div>
    <ItemListTable :fixedItemTypeId="2" />
  </div>
</template>

<script>
import ItemListTable from "@/modules/item/components/ItemListTable.vue";

export default {
  name: "IngredientsList",
  data() {
    return {};
  },
  components: {
    ItemListTable
  }
};
</script>
